import { render } from "./MonacoEditorMini.vue?vue&type=template&id=68827714&ts=true"
import script from "./MonacoEditorMini.vue?vue&type=script&lang=ts"
export * from "./MonacoEditorMini.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__